import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";
import OWNERSHIP_SEARCH_RESULT_INFO from "../../../../search/apollo/useSourcingToolResultInfo/sourcingToolResultInfo.gql";
import { SearchResultOwnershipInfoDTO } from "@landtechnologies/dtos";
import { cloneDeep } from "lodash";
type GetGeometriesForResultParams = {
  geometry_id: string;
};

export const getGeometriesForResult = async ({ geometry_id }: GetGeometriesForResultParams) => {
  const { data } = await routedClient.query<{
    searchResultOwnershipInfoByGeometry: SearchResultOwnershipInfoDTO & { __typename?: string };
  }>({
    query: OWNERSHIP_SEARCH_RESULT_INFO,
    variables: {
      geometry_id,
    },
    context: {
      endpoint: LandTechEndpoints.Gateway,
    },
  });
  const clonedData = cloneDeep(data);
  // We need to do this because we cannot change the type of geometry
  if (data.searchResultOwnershipInfoByGeometry?.geometry) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    delete clonedData.searchResultOwnershipInfoByGeometry.geometry.__typename;
  }
  return clonedData.searchResultOwnershipInfoByGeometry?.geometry;
};
